import { render } from "./joinUs.vue?vue&type=template&id=b0d13142&scoped=true&ts=true"
import script from "./joinUs.vue?vue&type=script&lang=ts"
export * from "./joinUs.vue?vue&type=script&lang=ts"

import "./joinUs.vue?vue&type=style&index=0&id=b0d13142&lang=less&scoped=true"

import exportComponent from "E:\\pc\\saas-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d13142"]])

export default __exports__